// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Performance Optimization CSS for TourKingdom Admin */

/* Smooth scrolling and hardware acceleration */
* {
  scroll-behavior: smooth;
}

html {
  -webkit-overflow-scrolling: touch; /* iOS smooth scrolling */
  scroll-behavior: smooth;
}

/* Hardware acceleration for common elements */
.transform-gpu {
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  will-change: transform;
}

/* Optimize scrollable containers */
.scroll-smooth {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

/* Reduce paint events during animations */
.will-change-scroll {
  will-change: scroll-position;
}

.will-change-transform {
  will-change: transform, opacity;
}

/* Optimize gradients for better performance */
.bg-gradient-to-br,
.bg-gradient-to-r,
.bg-gradient-to-l {
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

/* Smooth transitions for interactive elements */
button, 
.transition-all,
.transition-colors,
.transition-transform {
  transition: all 0.2s ease;
}

/* Prevent layout shifts */
img {
  display: block;
  max-width: 100%;
  height: auto;
}

/* Optimize table rendering */
table {
  table-layout: fixed;
  border-collapse: collapse;
}

/* Improve text rendering */
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

/* Reduce repaints on hover */
.hover\\:scale-\\[1\\.02\\]:hover {
  transform: scale(1.02) translateZ(0);
}

.hover\\:scale-110:hover {
  transform: scale(1.1) translateZ(0);
}

/* Optimize backdrop blur */
.backdrop-blur-sm,
.backdrop-blur-lg {
  backdrop-filter: blur(4px);
  will-change: backdrop-filter;
}

/* Reduce animation jank */
@keyframes spin {
  from {
    transform: rotate(0deg) translateZ(0);
  }
  to {
    transform: rotate(360deg) translateZ(0);
  }
}

@keyframes bounce {
  0%, 20%, 53%, 80%, 100% {
    transform: translate3d(0,0,0);
  }
  40%, 43% {
    transform: translate3d(0, -8px, 0);
  }
  70% {
    transform: translate3d(0, -4px, 0);
  }
  90% {
    transform: translate3d(0, -2px, 0);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: translateZ(0);
  }
  50% {
    opacity: 0.5;
    transform: translateZ(0);
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Validation animations */
.animate-fade-in {
  animation: fade-in 0.3s ease-out;
}

/* Form validation styles */
.validation-error {
  animation: fade-in 0.3s ease-out;
}

.validation-success {
  animation: fade-in 0.3s ease-out;
}

/* Optimize form elements */
input[type="text"],
input[type="email"],
input[type="password"],
textarea,
select {
  will-change: border-color, box-shadow;
}

/* Container queries optimization */
@container (min-width: 768px) {
  .container-optimized {
    contain: layout style paint;
  }
}

/* Reduce reflow during scrolling */
.fixed-header {
  contain: layout style paint;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 30;
}

/* Optimize list rendering */
ul, ol {
  contain: layout;
}

li {
  contain: layout style;
}

/* Virtual scrolling preparation */
.virtual-scroll-container {
  overflow: auto;
  will-change: scroll-position;
  contain: strict;
}

.virtual-scroll-item {
  contain: layout style paint;
}
`, "",{"version":3,"sources":["webpack://./src/performance.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD,+CAA+C;AAC/C;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC,EAAE,yBAAyB;EAC5D,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;EACE,wBAAwB;EACxB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,0CAA0C;AAC1C;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,8CAA8C;AAC9C;;;EAGE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,gDAAgD;AAChD;;;;EAKE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,2BAA2B;AAC3B;;EAGE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE;IACE,qCAAqC;EACvC;EACA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,0BAA0B;AAC1B;EACE,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;;;;;EAKE,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,mCAAmC;AACnC;EACE,2BAA2B;EAC3B,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* Performance Optimization CSS for TourKingdom Admin */\n\n/* Smooth scrolling and hardware acceleration */\n* {\n  scroll-behavior: smooth;\n}\n\nhtml {\n  -webkit-overflow-scrolling: touch; /* iOS smooth scrolling */\n  scroll-behavior: smooth;\n}\n\n/* Hardware acceleration for common elements */\n.transform-gpu {\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n  will-change: transform;\n}\n\n/* Optimize scrollable containers */\n.scroll-smooth {\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Reduce paint events during animations */\n.will-change-scroll {\n  will-change: scroll-position;\n}\n\n.will-change-transform {\n  will-change: transform, opacity;\n}\n\n/* Optimize gradients for better performance */\n.bg-gradient-to-br,\n.bg-gradient-to-r,\n.bg-gradient-to-l {\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n}\n\n/* Smooth transitions for interactive elements */\nbutton, \n.transition-all,\n.transition-colors,\n.transition-transform {\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n\n/* Prevent layout shifts */\nimg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n/* Optimize table rendering */\ntable {\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n\n/* Improve text rendering */\nbody {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n}\n\n/* Reduce repaints on hover */\n.hover\\:scale-\\[1\\.02\\]:hover {\n  transform: scale(1.02) translateZ(0);\n}\n\n.hover\\:scale-110:hover {\n  transform: scale(1.1) translateZ(0);\n}\n\n/* Optimize backdrop blur */\n.backdrop-blur-sm,\n.backdrop-blur-lg {\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n  will-change: backdrop-filter;\n}\n\n/* Reduce animation jank */\n@keyframes spin {\n  from {\n    transform: rotate(0deg) translateZ(0);\n  }\n  to {\n    transform: rotate(360deg) translateZ(0);\n  }\n}\n\n@keyframes bounce {\n  0%, 20%, 53%, 80%, 100% {\n    transform: translate3d(0,0,0);\n  }\n  40%, 43% {\n    transform: translate3d(0, -8px, 0);\n  }\n  70% {\n    transform: translate3d(0, -4px, 0);\n  }\n  90% {\n    transform: translate3d(0, -2px, 0);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: translateZ(0);\n  }\n  50% {\n    opacity: 0.5;\n    transform: translateZ(0);\n  }\n}\n\n@keyframes fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Validation animations */\n.animate-fade-in {\n  animation: fade-in 0.3s ease-out;\n}\n\n/* Form validation styles */\n.validation-error {\n  animation: fade-in 0.3s ease-out;\n}\n\n.validation-success {\n  animation: fade-in 0.3s ease-out;\n}\n\n/* Optimize form elements */\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"password\"],\ntextarea,\nselect {\n  will-change: border-color, box-shadow;\n}\n\n/* Container queries optimization */\n@container (min-width: 768px) {\n  .container-optimized {\n    contain: layout style paint;\n  }\n}\n\n/* Reduce reflow during scrolling */\n.fixed-header {\n  contain: layout style paint;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 30;\n}\n\n/* Optimize list rendering */\nul, ol {\n  contain: layout;\n}\n\nli {\n  contain: layout style;\n}\n\n/* Virtual scrolling preparation */\n.virtual-scroll-container {\n  overflow: auto;\n  will-change: scroll-position;\n  contain: strict;\n}\n\n.virtual-scroll-item {\n  contain: layout style paint;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
